<template>
  <div class="pdf-zoom">
    <a @click.prevent.stop="zoomIn"  :disabled="isDisabled"><span class="material-icons">zoom_in</span></a>
    <a @click.prevent.stop="zoomOut" :disabled="isDisabled"><span class="material-icons">zoom_out</span></a>
    <a @click.prevent.stop="fitWidth" :disabled="isDisabled"><span class="material-icons">zoom_out_map</span></a>
    <a @click.prevent.stop="fitAuto" :disabled="isDisabled"><span class="material-icons">fullscreen_exit</span></a>
  </div>
</template>

<script>
import ZoomInIcon from '../assets/icon-zoom-in.svg';
import ZoomOutIcon from '../assets/icon-zoom-out.svg';
import ExpandIcon from '../assets/icon-expand.svg';
import ShrinkIcon from '../assets/icon-shrink.svg';

export default {
  name: 'PDFZoom',

  components: {
    ZoomInIcon,
    ZoomOutIcon,
    ExpandIcon,
    ShrinkIcon,
  },

  props: {
    scale: {
      type: Number,
    },
    increment: {
      type: Number,
      default: 0.25,
    },
  },

  computed: {
    isDisabled() {
      return !this.scale;
    },
  },

  methods: {
    zoomIn() {
      this.updateScale(this.scale + this.increment);
    },

    zoomOut() {
      if (this.scale <= this.increment) return;
      this.updateScale(this.scale - this.increment);
    },

    updateScale(scale) {
      this.$emit('change', {scale});
    },

    fitWidth() {
      this.$emit('fit', 'width');
    },

    fitAuto() {
      this.$emit('fit', 'auto');
    },
  },
}
</script>

<style>
.pdf-zoom a {
  float: left;
  cursor: pointer;
  display: block;
  border: 1px #333 solid;
  background: white;
  color: #333!important;
  font-weight: bold;
  /* line-height: 1.5em; */
  width: 1.5em;
  height: 1.5em;
  font-size: 1.5em;
  padding: 5px;
  padding-top:4px;
}

.pdf-zoom a:hover{
  color: #333;
}
</style>
